import axios from 'axios'

export default {
  methods: {
    /**
     * Recache website page
     *
     * @param {string} url Page URL to recache
     * @returns {void}
     */
    recache (url = '') {
      url = process.env.APP_URL + url
      axios.post('https://api.prerender.io/recache', {
        prerenderToken: process.env.PRERENDER_TOKEN,
        url: url
      })
    },
    /**
     * Recache review detail page
     *
     * @param {string} bizSlug Business slug
     * @param {string} permalink Review permalink
     * @returns {void}
     */
    recacheReviewDetail (bizSlug, permalink) {
      this.recache(`/${bizSlug}/reviews/${permalink}`) // Review detail page
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/misc.js